module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-34.f26c8d63.svg";